import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const NavigationLink = ({ children, hasBreak, onClick, ...rest }) => {
  const className = `navlist__link${hasBreak ? ' navlist__link--break' : ''}`;

  return onClick ? (
    <a className={className} href="/" onClick={onClick}>
      {children}
    </a>
  ) : (
    <NavLink className={className} activeClassName="current" {...rest}>
      {children}
    </NavLink>
  );
};

NavigationLink.propTypes = {
  children: PropTypes.node.isRequired,
  hasBreak: PropTypes.bool,
  onClick: PropTypes.func
};

NavigationLink.defaultProps = {
  hasBreak: false,
  onClick: null
};

export default NavigationLink;



// WEBPACK FOOTER //
// ./src/components/NavigationLink/NavigationLink.js